<template v-else>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h2 class="cf-title cf-title--2">
        Oops!
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        Looks like the offer you selected has already been redeemed or is no longer available.
      </p>
    </div>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$closeModal('offerInStoreRedemption')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  export default {
    name: 'UnavailableOffer'
  };
</script>
